module.exports = __webpack_public_path__ + "static/media/slow_food.c2c3d539.mp4";